import { Trans } from '@lingui/react/macro';
import { useGetApiAuditLog } from '@sit/client-shared';
import { usePaginationState } from '@web/hooks/useLocalPagination';
import Form from 'carbon-react/lib/components/form';
import Button from '../Shared/Button';
import AuditTable from './AuditTable';
import { Audit } from './hooks/useAudit';

interface AuditDetailsProps {
  audit: Audit;
  companyId: string;
  onClose?: () => void;
}

function AuditDetails({ audit, companyId, onClose }: AuditDetailsProps) {
  const { page, pageSize, setPage, setPageSize } = usePaginationState();

  const handlePagination = (currentPage: number, pageSize: number) => {
    setPage(currentPage);
    setPageSize(pageSize);
  };

  const {
    data: auditLog,
    isLoading,
    isError,
    error,
  } = useGetApiAuditLog(
    {
      queryParams: {
        objectType: audit.objectType,
        key: audit.key,
        companyId: companyId,
        pageNumber: page.toString(),
        pageSize: pageSize.toString(),
      },
      requestConfig: {
        skipToast: true,
      },
    },
    {
      retry: 0,
    },
  );

  if (isError && error) {
    throw error;
  }

  return (
    <Form
      height="490px"
      stickyFooter
      saveButton={
        <Button
          buttonType={{
            default: 'primary',
            embedded: 'secondary',
          }}
          onClick={onClose}
          ml={1}
        >
          <Trans>Close</Trans>
        </Button>
      }
    >
      <AuditTable data={auditLog} loading={isLoading} page={page} pageSize={pageSize} onPaginate={handlePagination} />
    </Form>
  );
}

export default AuditDetails;
